const data = {
  companyName: '모바일웍스코리아',
  ceo: '김문규',
  address: '서울 구로구 디지털로26길 123\n지플러스타워 1108호, 모바일웍스코리아',
  tel: '+82 02 554 7496',
  fax: '+82 02 554 7458',
  email: 'mkt@mwkorea.co.kr',
  copyright: 'COPYRIGHT. MWKOREA. ALL RIGHT RESERVED.',
  description: '서비스기획, UX컨설팅, UI디자인, Mobile WEB, Application 구축 및 운영유지, 솔루션 제공을 하는 Mobile Total Solution Company',
};

export default data;
